import React,{ memo } from 'react'
import { Button, message } from 'antd'
import { FileExcelOutlined } from '@ant-design/icons'
import axios from 'axios'

/**
 * @description Componente que retorna un boton para descargar un archivo csv cualquiera
 * @returns 
 */
const DownloadCSV = memo(({
    title = "",
    tooltip = "Descargar CSV",
    url,
    params = {},
    icon = <FileExcelOutlined />
}) => {

    // Función para manejar la descarga del CSV
    const onClick = () => {
        if(!url) {
            message.error("No se proporcionó una URL para descargar el CSV");
            return;
        }

        // Construir la URL con los parámetros si existen
        let url_csv = new URL(axios.defaults.baseURL + url)
        if(Object.keys(params).length > 0) {
            Object.keys(params).forEach(key => url_csv.searchParams.set(key, params[key]))
        }
        url_csv.searchParams.set('Authorization', sessionStorage.getItem('token'))
        window.open(url_csv, '_blank');
    }


    return (
        <Button icon={icon} title={tooltip} onClick={onClick}>
            {title}
        </Button>
    )
})

export default DownloadCSV
